import { unwrapMutationWithTimeout } from './unwrapMutationWithTimeout'

/**
 * Try production DO createOrderTPO first; on any failure retry droplet
 * createNewOrderBrowser with the same body.
 */
export async function createOrderWithBackendFallback({
  createOrderTPO,
  createOrderLegacy,
  body,
  timeoutMs,
  onPrimaryFailure,
}) {
  try {
    const created = await unwrapMutationWithTimeout(
      createOrderTPO,
      body,
      timeoutMs,
    )
    return { created, backend: 'production' }
  } catch (primaryErr) {
    if (typeof onPrimaryFailure === 'function') {
      try {
        onPrimaryFailure(primaryErr)
      } catch (_) {
        /* never block fallback */
      }
    }

    try {
      const created = await unwrapMutationWithTimeout(
        createOrderLegacy,
        body,
        timeoutMs,
      )
      return { created, backend: 'droplet', primaryError: primaryErr }
    } catch (legacyErr) {
      const err = legacyErr || primaryErr
      if (err && typeof err === 'object') {
        err.primaryError = primaryErr
      }
      throw err
    }
  }
}
